"use client";

import { ContactForm } from "./contact-form";

export const ClientContactForm = ContactForm;
